<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('stations')"
      :columns="columns"
      :column_search="true"
      resource_url="/pilates_member/station/datatables"
    >
      <template v-slot:buttons>
        <!-- <button class="button is-secondary is-rounded" @click="availability">
          <span class="icon"><i class="fa fa-calendar"></i></span>
          <span>{{ $t("availability") }}</span>
        </button> -->
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <station-modal ref="station_modal" @success="refresh" />
  <!-- <availability-modal ref="availability_modal" /> -->
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import StationModal from "./station_modal/Index.vue";
// import AvailabilityModal from "./availability_modal/Index.vue";

export default {
  name: "StationDatatable",
  components: { GenericTable, StationModal /* AvailabilityModal */ },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            let icon = "check";
            let color = "";
            if (row.is_available) {
              icon = "check";
              color = "has-text-success";
            } else {
              icon = "times";
              color = "has-text-danger";
            }
            return `<span class="icon ${color}">
                      <i class="fa fa-${icon}"></i>
                    </span> ${row.name}`;
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   width: "80%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.station_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete station?"),
                    v,
                    () => {
                      del("/pilates_member/station", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.station_modal.show_modal();
    },
    // availability() {
    //   let v = this;
    //   v.$refs.availability_modal.show_modal();
    // },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
